import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

export interface IDoctorListItem {
  user_id: string;
  name: string;
  email: string;
}

interface IDoctorListResponse {
  status: boolean;
  message: string;
  data: IDoctorListItem[];
}

export const useDoctorListByClinicAPI = () => {
  const [doctorList, setDoctorList] = useState<IDoctorListItem[]>([]);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (clinicIds: string | string[], includeNonRota = false) => {
    const ids = Array.isArray(clinicIds) ? clinicIds : [clinicIds];
    const validIds = ids.filter(Boolean);
    if (!validIds.length) return;

    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .post(
          INVENTORY_MODULE.CLINIC_TO_DOCTOR_TRANSFER_DOCTORS.baseURL,
          { clinic_ids: validIds, include_non_rota: includeNonRota },
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then((res: AxiosResponse<IDoctorListResponse>) => {
          if (res.data.status === true) {
            setDoctorList(res.data.data ?? []);
          } else {
            setDoctorList([]);
          }
        })
        .catch((e: AxiosError) => {
          captureError(e);
          setDoctorList([]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, []);

  return { execute, doctorList };
};
